import { AttributeConfigContext } from "@src/context/attributeConfig/AttributeConfigContext";
import * as process from "process";
import * as React from "react";

export const TrackingProvider: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => {
    const { trackingEnabled, trackingConfig } = React.useContext(AttributeConfigContext);
    const [trackingCodeAdded, setTrackingCodeAdded] = React.useState(false);

    React.useEffect(() => {
        if ((process.env.BUILD_ENV === "prod" || process.env.BUILD_ENV === "staging") && trackingEnabled && trackingConfig && !trackingCodeAdded) {
            setTrackingCodeAdded(true);
            const script = document.createElement("script");

            const jentisEnvironment = process.env.BUILD_ENV === "prod" ? "live" : "stage";

            script.textContent =
                "(function (sCDN, sCDNProject, sCDNWorkspace, sCDNVers) {\n" +
                "    if (\n" +
                "      window.localStorage !== null &&\n" +
                '      typeof window.localStorage === "object" &&\n' +
                '      typeof window.localStorage.getItem === "function" &&\n' +
                "      window.sessionStorage !== null &&\n" +
                '      typeof window.sessionStorage === "object" &&\n' +
                '      typeof window.sessionStorage.getItem === "function"\n' +
                "    ) {\n" +
                "      sCDNVers =\n" +
                '        window.sessionStorage.getItem("jts_preview_version") ||\n' +
                '        window.localStorage.getItem("jts_preview_version") ||\n' +
                "        sCDNVers;\n" +
                "    }\n" +
                "    window.jentis = window.jentis || {};\n" +
                "    window.jentis.config = window.jentis.config || {};\n" +
                "    window.jentis.config.frontend = window.jentis.config.frontend || {};\n" +
                "    window.jentis.config.frontend.cdnhost =\n" +
                '      sCDN + "/get/" + sCDNWorkspace + "/web/" + sCDNVers + "/";\n' +
                "    window.jentis.config.frontend.vers = sCDNVers;\n" +
                "    window.jentis.config.frontend.env = sCDNWorkspace;\n" +
                "    window.jentis.config.frontend.project = sCDNProject;\n" +
                "    window._jts = window._jts || [];\n" +
                '    var f = document.getElementsByTagName("script")[0];\n' +
                '    var j = document.createElement("script");\n' +
                "    j.async = true;\n" +
                `    j.src = window.jentis.config.frontend.cdnhost + "${trackingConfig.fileHash}js";\n` +
                "    f.parentNode.insertBefore(j, f);\n" +
                `  })("https://${trackingConfig.trackId}.sparepartsfinderwebcomponent.dealerhub.com","${trackingConfig.trackDomain}","${jentisEnvironment}", "_");\n` +
                "\n" +
                '  _jts.push({ track: "pageview" });\n' +
                '  _jts.push({ track: "submit" });';

            document.head.appendChild(script);
        }
    }, [trackingEnabled, trackingConfig, trackingCodeAdded]);

    return <>{children}</>;
};
